module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id",
      "id": "id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.api_name == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("API名称")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.api_name),
      expression: "biz.api_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "api_name",
      "id": "api_name"
    },
    domProps: {
      "value": (_vm.biz.api_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "api_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.caller == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("CALLER")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.caller),
      expression: "biz.caller"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "name": "caller",
      "id": "caller"
    },
    domProps: {
      "value": (_vm.biz.caller)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "caller", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.name == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("是否检查SESSION")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.need_check_session),
      expression: "biz.need_check_session"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.biz, "need_check_session", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.name == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("是否检查SIGN")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.need_check_sign),
      expression: "biz.need_check_sign"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.biz, "need_check_sign", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a683be2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/ApiAcsEdit.vue
// module id = 315
// module chunks = 2 3